import { EnumStatusIndicacao } from "model/enums/enum-status-indicacao";

export class RelatorioIndicacaoModel {
    constructor(
        public status: string = '',
        public quantidade: number = 0,
        public statusEnum: EnumStatusIndicacao = EnumStatusIndicacao.Disponivel,
    ) { }
}